import type { State } from '../../types';
import type { IssueViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function issuesNotDeleted(state: State): IssueViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.issuesById).filter((e) => !e.deleted);
}
